module.exports = __webpack_public_path__ + "img/red_046.3d212de3.png";